import { ICompanyMemberRequest } from '@/features/company-members/store/models/company-members.model';
import { createHttpHeader } from '@/utils/network/createHTTPHeaders';
import { decryptTreezorResponse } from '@/services/encryption/decryptTreezorResponse';
import { IUser } from '@/features/user/store/user.model';
import { getStaticDashboardConfig } from '@/hooks/useDashboardConfig';
import { fetchQuery } from '@/utils/queryClient';
import { fetchMethods } from '@/types/FetchService.types';

export class CompanyMemberService {
  static queryKey = 'CompanyMembers';

  static searchChildrenUsers = async ({ parentUserId, ...searchParams }: ICompanyMemberRequest): Promise<IUser[]> => {
    try {
      const config = getStaticDashboardConfig();
      const params = new URLSearchParams();
      params.set('parentUserId', parentUserId.toString());

      Object.entries(searchParams).map(([key, value]) => !!value && params.set(key, value.toString()));

      const usersResponse = await fetchQuery(
        [
          this.queryKey,
          {
            method: fetchMethods.GET,
            action: 'search children',
            params: Object.fromEntries(params),
          },
        ],
        `${config.api.baseUrl}/v1/users?${params.toString()}`,
        {
          headers: createHttpHeader(),
          staleTime: 60000,
        },
      );

      return await decryptTreezorResponse<IUser>(usersResponse, { isSequential: true });
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
